import { GeneralFetch } from "Api/generalFetch/generalFetch"
import { useEffect, useState } from "react"

export function getUsers() {
    const [users, setUsers] = useState([])
    const { fetchData, loading } = GeneralFetch()

    useEffect(() => {
        const fetchDataAsync = async () => {
            await fetchData({}, 'userList', 'get', 'users').then((resp) => {
                let formatedUSers = resp?.users?.map((user) => { return { label: user.name, value: user.id, local: user.local_id, acesso: JSON.parse(user.acesso) } })
                setUsers(formatedUSers)
            })
        }

        void fetchDataAsync();
    }, [])

    return { users, loading }
}